import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import InfoTooltipSvg from '@/components/common/InfoTooltipSvg';
import MergeSvg from '@/components/common/MergeSvg';
import { Storage } from '@/tscapi/utils/browser-storage';
import { Cookie } from '@/tscapi/utils/cookie';

import { CartContext } from '../../contexts/CartContext';

export interface NotificationMsgProps {
    isQuebec: boolean;
    setIsQuebec: any;
}

export const NotificationMsg = ({ isQuebec, setIsQuebec }: NotificationMsgProps) => {
    const { t, i18n } = useTranslation();
    const { cartData, serverErrorMessage, orderHistoryDetail } = useContext(CartContext);
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    useEffect(() => {
        const cookie = new Cookie();
        const storage = new Storage();
        const changeLanguage = (lng) => {
            i18n.changeLanguage(lng);
        };

        if (typeof cartData != undefined) {
            if (cookie.ModifyOrderNumber != undefined && cookie.ModifyOrderNumber.length > 0) {
                // customer is from Quebec but in order mod mode
                if (cartData && orderHistoryDetail) {
                    if (
                        (cookie.getValue('TSC_Language') == undefined || cookie.Language?.toLowerCase() == 'en_ca') &&
                        storage.getLanguageForced() != '1' &&
                        (orderHistoryDetail?.BillingCityProvincePostalCode.indexOf('QC-') > -1 ||
                            orderHistoryDetail?.ShipLevels[0]?.ShipCityProvincePostalCode.indexOf('QC-') > -1)
                    ) {
                        setIsQuebec(true);
                        storage.setLanguageForced('1');
                        changeLanguage('fr');
                        cookie.Language = 'fr_CA';
                    } else {
                        setIsQuebec(false);
                    }
                }
            } else {
                //if customer is from Quebec and arrived with language set to EN, switch to FR
                if (
                    (cookie.getValue('TSC_Language') == undefined || cookie.Language?.toLowerCase() == 'en_ca') &&
                    storage.getLanguageForced() != '1' &&
                    (cartData?.Buyer?.BillingAddress?.State == 'QC' || cartData?.ShippingAddress?.State == 'QC')
                ) {
                    setIsQuebec(true);
                    storage.setLanguageForced('1');
                    changeLanguage('fr');
                    cookie.Language = 'fr_CA';
                } else {
                    setIsQuebec(false);
                }
            }
        }
    }, [i18n, cartData, setIsQuebec, orderHistoryDetail]);

    if (serverErrorMessage) {
        const analyticsData = window['analyticsData'] || {};
        analyticsData.page = analyticsData.page || {};
        analyticsData.error = serverErrorMessage;
    }

    return (
        <>
            {isQuebec && (
                <div className="notification__quebec-wrap">
                    <InfoTooltipSvg className="notification__quebec-svg" />
                    <div className="">
                        <span>
                            Votre adresse de facturation et/ou de livraison étant au Québec, vous recevez votre
                            récapitulatif de commande en français.
                        </span>{' '}
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                const cookie = new Cookie();
                                const storage = new Storage();
                                cookie.Language = 'en_CA';
                                changeLanguage('en');
                                setIsQuebec(false);
                            }}
                        >
                            Consulter en anglais
                        </a>
                    </div>
                </div>
            )}

            {cartData && cartData.IsCartMerged && (
                <div className="notification__merge-wrap">
                    <MergeSvg className="notification__merge-svg" />
                    <span> {t('Merged Items Note')}</span>
                </div>
            )}

            {serverErrorMessage && (
                <div className="alert alert-danger">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        className="form__error-svg"
                    >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
                    </svg>
                    {serverErrorMessage}
                </div>
            )}
        </>
    );
};
